module.exports = __webpack_public_path__ + "media/images/prev-84b76dee.png";